import _ from 'lodash';

import {logger} from '../../srcCommon/services/logger/logger';
import {DelegationModel} from '../models/api/delegationModel';
import {PreferencesModel} from '../models/api/preferencesModel';
import {TeammateModel} from '../models/api/teammateModel';
import {ResourceMap} from '../store/appTypes';

/*
 * Helpers.
 * TODO: Remove when PB-30756 is done.
 */

export const lazyTeammatesLogger = logger.getLogger('lazy-teammates');

export function buildInitialLazyTeammates(
  teammates: ResourceMap<TeammateModel>,
  userId: number,
  preferences: PreferencesModel,
  delegations: ResourceMap<DelegationModel>,
  hasLazyTeammates: boolean,
): ResourceMap<TeammateModel> {
  if (!hasLazyTeammates) {
    return {};
  }

  const displayedTeammateIdsSet = new Set(preferences.displayedTeammateIds || []);
  const userDelegationOwnerIds = new Set(
    _(delegations)
      .values()
      .compact()
      .filter((d) => d.teammateIds.includes(userId))
      .map((d) => d.ownerId)
      .value(),
  );

  return _(teammates)
    .values()
    .compact()
    .filter((t) => shouldKeepTeammate(t, userId, displayedTeammateIdsSet, userDelegationOwnerIds))
    .keyBy('id')
    .value();
}

/** Whether we'd expect the server to return this teammate in the future. */
function shouldKeepTeammate(
  teammate: TeammateModel,
  userId: number,
  displayedTeammateIdsSet: Set<number>,
  userDelegationOwnerIds: Set<number>,
) {
  if (teammate.id === userId) {
    // Keep the current user.
    return true;
  }

  if (displayedTeammateIdsSet.has(teammate.id)) {
    // Keep teammates pinned in P1.
    return true;
  }

  if (userDelegationOwnerIds.has(teammate.id)) {
    // Keep the owners of delegations the user has access to.
    return true;
  }

  return false;
}
